import React from 'react';
import styles from './StatisticsIcon.module.scss';

const StatisticsIcon = props => {
    return <i className={`icon-statistic ${styles.icon}`} {...props} />;
};

export default StatisticsIcon;
